import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchDeleteCard = async (cardId, activeEmployerInfo) => {
  const apiPath = `cards/card/${cardId}/set-as-deleted`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {},
    activeEmployerInfo,
  });
  const response = await axios(signedRequest);

  return response.data;
};
